import authReducers from "../../../secrets-web/src/store/reducers/modules/auth"
import initial from "../../initial"
import actionTypes from "../../actionTypes";

const userInfo = (state = initial.auth, action) => {
  switch (action.type) {
    case actionTypes.SET_USER_PM:
      return { ...state, userPm: action.payload };
    default:
      return authReducers(state, action);
  }
};

export default userInfo;
